import styled from 'styled-components';
import { Container } from 'react-bootstrap';
import { PRIMARY, BACKGROUND_COLOR, WHITE } from '../../utils/colors';

export const CertificationsContainer = styled(Container)`
  padding: 150px 50px;
  background-color: ${BACKGROUND_COLOR};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  /* gap: 3rem; */
  /* flex-wrap: wrap; */
  @media (max-width: 800px) {
    padding: 50px 20px;
    flex-direction: column;
  }
`

export const CertificationsImage = styled.img`
  width: 200px;
  object-fit: cover;
  @media (max-width: 800px) {
    width: 150px;
    height: auto;
    margin-bottom: 20px;
  }
`

export const CertificationItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 400px;
  height: 100%;
  justify-content: center;
  align-items: center;
  
`

export const CertificationsTitle = styled.div`
  /* background-color: ${WHITE}; */
  padding: 8px;
  border-radius: 12px;
  font-family: 'FigtreeBold', 'sans-serif';
  font-size: 1.2rem;
  text-align: center;
  color: ${PRIMARY};
`

export const CertificationsDescription = styled.div`
  /* background-color: ${WHITE}; */
  padding: 8px;
  border-radius: 12px;
  font-family: 'FigtreeBold', 'sans-serif';
  font-size: 0.8rem;
  text-align: center;
`